<template>
    <p-secure require-admin>
        <p-search-screen
            ref="searchScreen"
            title="Data Exchange"
            api-destination="dataexchange"
            :filters="filters"
            :filterBy="filterBy"
            :fields="fields"
            add-new-button
            :use-is-active-checkbox="false"
            edit-key="cronJobId"
        >
        <template v-slot:actionButtons>
            <p-button
                variant="outline-primary"
                type="button"
                @click="openJobLog"
                >Job Log</p-button
            >
        </template>
            <template v-slot:belowSearch>
                <div class="d-flex align-items-center gap-3">
                    <p-checkbox
                        label="Active"
                        v-model="filters.active"
                    />
                    <p-checkbox
                        label="Inactive"
                        v-model="filters.inactive"
                    />
                </div>
            </template>
            <template v-slot:cell(delete)="{ value, item }">
                        <b-button class="p-1 ms-1 short-button" @click="deleteJob(item)">
                            <BIconTrash icon="trash"
                                       ></BIconTrash>
                        </b-button>
                    </template>
        </p-search-screen>
    </p-secure>
</template>

<script>
import axios from 'axios';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
import { isActiveFormatter, datetimeToLocalTimeFormatter } from '@/components/Common/Formatters.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'DataExchangeFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'name',
                sortDesc: true,
                searchBy:'All',
                active: true,
                inactive: true,
                returnOnlyActiveRecords: null
            },
            filterBy:[
                'All',
                'Job Name',
                'Description'
            ],
            fields: [
                {
                    key: 'name',
                    label:'Job Name',
                    sortable: true
                },
                {
                    key: 'description',
                    sortable: true
                },
                {
                    key: 'lastRunDate',
                    label:'Last Run',
                    sortable: true,
                    formatter: datetimeToLocalTimeFormatter
                },
                {
                    key: 'action',
                    sortable: true
                },
                {
                    key: 'cronJobType',
                    label:'Type',
                    sortable: true
                },
                {
                    key: 'isActive',
                    label:'Status',
                    sortable: true,
                    formatter: isActiveFormatter
                },
                {
                        key: 'delete',
                        label: 'Delete'
                }
            ]
        };
    },
    watch: {
        'filters.active': 'syncActiveFilter',
        'filters.inactive': 'syncActiveFilter'
    },
    methods: {
        // Map the two active/inactive checkboxes onto the single
        // `returnOnlyActiveRecords` backend filter so the API doesn't change.
        syncActiveFilter() {
            if (this.filters.active && this.filters.inactive) {
                this.filters.returnOnlyActiveRecords = null;
            } else if (this.filters.active) {
                this.filters.returnOnlyActiveRecords = true;
            } else if (this.filters.inactive) {
                this.filters.returnOnlyActiveRecords = false;
            } else {
                this.filters.returnOnlyActiveRecords = null;
            }
        },
        deleteJob(item) {
            this.$bvModal
                .msgBoxConfirm('Are you sure you want to delete this Job?')
                .then(value => {
                    if (value) {
                        axios.post('dataexchange/delete', item).then(resp => {
                            if (resp) {
                                this.$appSuccess(
                                        `${item.name} deleted successfully.`
                                    );
                                this.$refs.searchScreen.refreshSearchResults();
                            }
                        });
                    }
                });
         },
        openJobLog(){
            this.$router.push('dataexchange/log');
        }
    }        
};
</script>
<style scoped lang="scss">
:deep(.custom-select) {
    height: 43px;
}
</style>
